var render = function () {
  var _vm$$props$swatchData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('custom-container', {
    attrs: {
      "elementType": "div",
      "customClass": _vm.$props.customsClasses
    }
  }, [_c('custom-tooltip', {
    attrs: {
      "customsClasses": "tooltip-swatch-tray"
    }
  }, [_c('CustomText', {
    attrs: {
      "elementType": "span",
      "customClass": "tooltip-swatch-tray-text",
      "text": _vm.$props.swatchData.display_name.default
    }
  })], 1), _c('swatch-background', {
    attrs: {
      "isSelected": false,
      "color": _vm.$props.swatchData.color,
      "image": (_vm$$props$swatchData = _vm.$props.swatchData.image_assets) === null || _vm$$props$swatchData === void 0 ? void 0 : _vm$$props$swatchData.ui,
      "customsClasses": "background"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }